import EventEmitter from "./EventEmitter";

const SWIPE_THRESHOLD = 30;
const TAP_MAX_MOVE = 10;
const TAP_MAX_TIME = 250;

export default class Input extends EventEmitter {
  constructor() {
    super();

    this.keys = new Set();

    this._touchStart = null;
    this._mouseDownAt = null;

    this._onKeyDown = this._onKeyDown.bind(this);
    this._onKeyUp = this._onKeyUp.bind(this);
    this._onTouchStart = this._onTouchStart.bind(this);
    this._onTouchEnd = this._onTouchEnd.bind(this);
    this._onTouchMove = this._onTouchMove.bind(this);
    this._onMouseDown = this._onMouseDown.bind(this);
    this._onMouseUp = this._onMouseUp.bind(this);

    window.addEventListener("keydown", this._onKeyDown);
    window.addEventListener("keyup", this._onKeyUp);
    window.addEventListener("touchstart", this._onTouchStart, { passive: false });
    window.addEventListener("touchmove", this._onTouchMove, { passive: false });
    window.addEventListener("touchend", this._onTouchEnd, { passive: false });
    window.addEventListener("mousedown", this._onMouseDown);
    window.addEventListener("mouseup", this._onMouseUp);
  }

  _onKeyDown(e) {
    if (e.repeat) return;
    const code = e.code;
    this.keys.add(code);

    switch (code) {
      case "ArrowLeft":
      case "KeyA":
        e.preventDefault();
        this.trigger("left");
        break;
      case "ArrowRight":
      case "KeyD":
        e.preventDefault();
        this.trigger("right");
        break;
      case "Space":
        e.preventDefault();
        this.trigger("shoot");
        break;
      case "Enter":
        this.trigger("start");
        break;
      case "KeyR":
        this.trigger("restart");
        break;
      case "Escape":
        this.trigger("pause");
        break;
    }
  }

  _onKeyUp(e) {
    this.keys.delete(e.code);
  }

  _onTouchStart(e) {
    if (e.touches.length !== 1) return;
    const t = e.touches[0];
    this._touchStart = { x: t.clientX, y: t.clientY, time: performance.now(), moved: false };
  }

  _onTouchMove(e) {
    if (!this._touchStart) return;
    const t = e.touches[0];
    const dx = t.clientX - this._touchStart.x;
    const dy = t.clientY - this._touchStart.y;
    if (Math.hypot(dx, dy) > TAP_MAX_MOVE) this._touchStart.moved = true;
  }

  _onTouchEnd(e) {
    if (!this._touchStart) return;
    const start = this._touchStart;
    this._touchStart = null;

    const t = e.changedTouches[0];
    const dx = t.clientX - start.x;
    const dy = t.clientY - start.y;
    const dt = performance.now() - start.time;

    if (!start.moved && dt < TAP_MAX_TIME) {
      this.trigger("shoot");
      return;
    }

    if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > SWIPE_THRESHOLD) {
      this.trigger(dx < 0 ? "left" : "right");
    }
  }

  _onMouseDown(e) {
    this._mouseDownAt = { x: e.clientX, y: e.clientY, time: performance.now() };
  }

  _onMouseUp(e) {
    if (!this._mouseDownAt) return;
    const start = this._mouseDownAt;
    this._mouseDownAt = null;

    const dx = e.clientX - start.x;
    const dy = e.clientY - start.y;
    const dt = performance.now() - start.time;

    if (Math.hypot(dx, dy) < TAP_MAX_MOVE && dt < TAP_MAX_TIME) {
      this.trigger("shoot");
    }
  }

  destroy() {
    window.removeEventListener("keydown", this._onKeyDown);
    window.removeEventListener("keyup", this._onKeyUp);
    window.removeEventListener("touchstart", this._onTouchStart);
    window.removeEventListener("touchmove", this._onTouchMove);
    window.removeEventListener("touchend", this._onTouchEnd);
    window.removeEventListener("mousedown", this._onMouseDown);
    window.removeEventListener("mouseup", this._onMouseUp);
  }
}
